<template>
  <div class="favorite-recipe-carroussel">
    <div class="h8" style="margin-bottom:1rem;">MES OBSESSIONS DU MOMENT</div>
      <div v-if="isLargeScreen">
        <vueper-slides 
          class="no-shadow"
          :touchable="false"
          :visible-slides="3"
          :gap="3"
          :slide-ratio="1 / 4"
          :arrows-outside="false"
          autoplay>
          <vueper-slide
            v-for="(recipe, i) in displayRecipes"
            :key="i"
            :title="recipe.name"
            :image="getImagePath(recipe.photoName, recipe.photoUrl)"
            :link="getRecipeLink(recipe.id)"
            :style="'color:white;text-decoration:none;'">
          </vueper-slide>
        </vueper-slides>
      </div>
      <div v-else> 
        <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        background="#fff"
        style="text-shadow: 1px 1px 2px #333;"
        label-prev=""
        label-next=""
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <div v-for="recipe in displayRecipes" :key="recipe.id" @click="goToRecipe(recipe.id)">
          <b-carousel-slide :img-src="getImagePath(recipe.photoName, recipe.photoUrl)">
            <template #img>
              <div class="carousel-image-wrapper">
                <img
                  class="carousel-recipe-img"
                  :src="getImagePath(recipe.photoName, recipe.photoUrl)"
                  alt="image slot"
                >
              </div>
            </template>
            <h5>{{ recipe.name }}</h5>
          </b-carousel-slide>
        </div>
      </b-carousel>
      </div>
    </div>
</template>

<script>
import FirebaseDataService from '../services/FirebaseDataService.js';
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  name: 'FavoriteRecipeCarroussel',
  components: {
    VueperSlides, 
    VueperSlide
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      displayRecipes: [],
      isLargeScreen: window.innerWidth >= 1400
    };
  },
  computed: {
    getRecipeLink() {
      return (recipeId) => `/recipe/${recipeId}`;
    }
  },
  async mounted() {
    await this.loadFavoriteRecipes();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async loadFavoriteRecipes() {
      try {
        this.displayRecipes = await FirebaseDataService.getFavoriteRecipes();
      } catch (error) {
        console.error('Erreur lors du chargement des recettes favorites:', error);
      }
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    getImagePath(photoName, photoUrl = null) {
      if (!photoName) return '';
      
      // If there's a Firebase URL (new uploads), use it directly
      if (photoUrl && photoUrl.includes('firebase')) {
        return photoUrl;
      }
      
      // Otherwise, try to load from local assets (existing images)
      try {
        return require(`@/assets/images/${photoName}`);
      } catch (error) {
        // If local image doesn't exist and we have a URL, try that
        if (photoUrl) {
          return photoUrl;
        }
        return '';
      }
    },
    handleResize() {
      this.isLargeScreen = window.innerWidth >= 1400;
    },
    goToRecipe(recipeId){
      this.$router.push(`/recipe/${recipeId}`)
    }
  }
}
</script>

<style scoped>
.favorite-recipe-carroussel{
  margin: 1rem;
  border-radius: 12px;
}

.carousel-image-wrapper {
  position: relative;
  width: 100%;
  padding-top: 46.875%; /* Aspect ratio 1024 / 480 = 2.1333, so 480 / 1024 * 100% = 46.875% */
  overflow: hidden;
}

.carousel-recipe-img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}
</style>
